import React, { FC } from 'react';
import './ProgressBar.module.css';

export interface ProgressBarProps {
  color: string;
  completed: number;
  progressHeight?: string;
  progressWidth?: string;
}

export const ProgressBar: FC<ProgressBarProps> = (props: ProgressBarProps) => {
  const { color, completed, progressHeight, progressWidth } = props;

  const containerStyles = {
    height: progressHeight ?? '10px',
    width: progressWidth ?? '100%',
  };

  const fillerStyles = {
    width: `${completed}%`,
    background: color,
  };

  return (
    <div className="progressBarContainer" style={containerStyles}>
      <div className="fill" style={fillerStyles}></div>
    </div>
  );
};
